import { timeline, type TimelineEvent } from "@/mocks/timeline";

const toneMap: Record<
  TimelineEvent["tone"],
  { dot: string; line: string; badge: string; label: string }
> = {
  start: { dot: "bg-accent-500", line: "bg-accent-300", badge: "bg-accent-100 text-accent-900", label: "升温" },
  rise: { dot: "bg-accent-500", line: "bg-accent-300", badge: "bg-accent-100 text-accent-900", label: "升温" },
  storm: { dot: "bg-primary-500", line: "bg-primary-200", badge: "bg-primary-100 text-primary-700", label: "爆发" },
  answer: { dot: "bg-secondary-500", line: "bg-secondary-300", badge: "bg-secondary-100 text-secondary-900", label: "观察" },
};

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="font-bebas text-sm tracking-[0.2em] text-primary-500">HOW IT ALL WENT DOWN</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            风评时间线 · <span className="text-primary-500">这场瓜怎么越滚越大</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            从爆火到争议再到当下的观望，按时间还原哇偶姐姐风评的完整走向，看舆论是如何一步步变化的。
          </p>
        </div>

        <ol className="relative mt-12 space-y-0 border-l border-background-300 pl-6 md:pl-10">
          {timeline.map((e, i) => {
            const t = toneMap[e.tone];
            return (
              <li key={e.id} className="relative pb-9 last:pb-0">
                <span className={`absolute -left-[31px] top-1 h-3.5 w-3.5 rounded-full ring-4 ring-background-100 md:-left-[47px] ${t.dot}`} aria-hidden="true" />
                <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-2.5">
                    <span className="font-bebas text-2xl text-primary-500">{e.stage}</span>
                    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${t.badge}`}>
                      <i className={`mr-1 ${e.tone === "storm" ? "ri-fire-fill" : "ri-time-line"}`} aria-hidden="true" />
                      {t.label}
                    </span>
                    <span className="ml-auto text-xs text-foreground-500">{e.date}</span>
                  </div>
                  <h3 className="font-heading mt-3 text-lg font-bold text-foreground-950">{e.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-700">{e.desc}</p>
                </div>
              </li>
            );
          })}
        </ol>

        <p className="mt-8 rounded-xl bg-background-50 p-4 text-center text-xs leading-5 text-foreground-500">
          时间线按事件阶段归纳，用于示意讨论节奏；具体时间与细节请以各平台真实内容为准。
        </p>
      </div>
    </section>
  );
}